<template>
  <div>
    <page-heading title="User Information" :loading="exists">
      <div slot="buttons">
        <table>
          <tr>
            <td><h4>Efficiency Score</h4> </td>
            <td>
              <el-progress :percentage="25" :text-inside="true" :stroke-width="10" :width="70"></el-progress>
            </td>
          </tr>
        </table>
      </div>
    </page-heading>
    <el-row :gutter="20">
      <el-col :lg="12" :md="24">
        <user-profile :userId="userId"></user-profile>
        <schedule :userId="userId" />
        <pto-availability :userId="userId" />
      </el-col>
      <el-col :lg="12" :md="24">
        <el-card>
          <div slot="header">
            All Timesheets
          </div>
          <timesheets-list :timesheets="archivedTimesheets"></timesheets-list>
        </el-card>
        <user-memberships-list :userId="userId"></user-memberships-list>
        <activity-logs :userId="userId" :showLink="false" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import UserProfile from '@/components/profile/UserProfile';
  import EfficiencyScore from '@/components/EfficiencyScore';
  import Schedule from '@/components/schedule/Schedule';
  import PtoAvailability from '@/components/ptoAvailability/PtoAvailability';
  import ActivityLogs from '@/components/activityLog/ActivityLogs';
  import UserMembershipsList from '@/components/userMembership/UserMembershipsList';
  import TimesheetsList from '@/components/timesheet/TimesheetsList';

  export default {
    name: 'UserProfilePage',
    components: {
      userProfile: UserProfile,
      schedule: Schedule,
      ptoAvailability: PtoAvailability,
      activityLogs: ActivityLogs,
      userMembershipsList: UserMembershipsList,
      efficiencyScore: EfficiencyScore,
      timesheetsList: TimesheetsList,
    },
    data() {
      return {
        translationPrefix: 'pages.userProfile',
        userId: parseInt(this.$router.currentRoute.params.id, 10),
      };
    },
    computed: {
      ...mapGetters('entities/users', ['fetching']),
      ...mapGetters('entities/timesheets', ['fetching']),

      archivedTimesheets() {
        return this.$store.getters['entities/timesheets/query']()
          .with('user.profile')
          .where(record => record.user_id === this.userId)
          .get();
      },
      exists() {
        this.fetchSingleUser({ id: this.userId })
          .then((response) => {
            if (!response.status) {
              // this.$router.push({ name: 'users' });
            }
            return response.status;
          });
      },
    },
    methods: {
      ...mapActions('entities/users', ['fetchSingleUser']),
      ...mapActions('entities/timesheets', ['fetchTimesheets']),
    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/UserProfile.vue